import axios from './axios';

export const getCampuses = () => axios.get('/core/campuses');

export const getActiveAbsences = query => axios.post('/students/absences/search', query);
